import { useLanguage } from "../context/LanguageContext";

export const Marquee = () => {
  const { t } = useLanguage();
  const items = [...t.marquee, ...t.marquee];

  return (
    <div className="overflow-hidden border-y border-white/10 bg-basalt py-5" data-testid="editorial-marquee">
      <div className="marquee-track flex items-center">
        {items.map((item, i) => (
          <span
            key={i}
            className="flex items-center whitespace-nowrap font-mono text-xs uppercase tracking-[0.35em] text-sand/50"
          >
            <span className="px-8">{item}</span>
            <span className="text-terracotta">•</span>
          </span>
        ))}
      </div>
    </div>
  );
};
